export const EMPTY_LOCALE = '';
